<style lang="less" scoped>
@import "./index.less";
</style>

<template>
  <div class="phone-binding " :class="bindingBG">
    <div class="form">
      <div class="input-wrap">
        <van-popover v-model="showPopover" trigger="click" :actions="prePhone" @select="onSelect">
          <template #reference>
            <div class="pre-mobile">{{ prePhoneText }}</div>
          </template>
        </van-popover>
        <input v-model="bdPhoneNumber" type="tel" placeholder="请输入手机号码" />
        <button :disabled='countDisabled' @click="getWxVerifyCodeFn">{{ bdYzmText }}</button>
      </div>
      <div class="input-wrap">
        <input v-model="bdVerifyCode" inputmode="numeric" placeholder="请输入验证码" />
      </div>
      <div style="width: 100%; text-align: center;">
        <button class="submit" :disabled="(!bdPhoneNumber && !bdPhoneNumber)" @click="bindPhone">提交</button>
      </div>
    </div>
  </div>
</template>

<script>

import { Field, Form, Popover } from 'vant'
import { formCheck } from '../../../../assets/js/xjpublic'
export default {
  name: 'home',
  components: {
    [Field.name]: Field,
    [Form.name]: Form,
    [Popover.name]: Popover
  },
  data() {
    return {
      bdPhoneNumber: "",
      bdYzmText: '获取验证码',
      countDisabled: false,
      bdVerifyCode: '',
      prePhoneText: "+86",
      prePhoneValue: "",
      showPopover: false,
      bindingBG:"",
      // 通过 actions 属性来定义菜单选项
      prePhone: [
        { text: '选择地区', disabled: true },
        {
          text: '+86',
          value: '',
        }, {
          text: '+852',
          value: '852',
        }, {
          text: '+886',
          value: '886',
        }, {
          text: '+853',
          value: '853',
        }]
    }
  },
  methods: {
    onSelect(action) {
      this.prePhoneText = action.text;
      this.prePhoneValue = action.value
    },
    bindPhone(){
      let res = this.$axios.post('/v3/u/user/wxVerifyCode', {
        mobile: this.bdPhoneNumber,
        code: this.bdVerifyCode,
        origin: 'weChat',
      }).then((res)=>{
        if (!res || res.data.ret !== 0) {
          this.$dialog({
            message: res.data.msg || '验证码错误'
          });
        }else{
          this.$toast.loading({
            mask: true,
            duration: 0,
            message: '登录中...'
          });
          const {imei,scanImei,scanSn} = res.data.data;
          if(scanImei&&scanSn){
            this.predictCarInfo(scanImei,scanSn)
          }else if(imei){
            this.setDefaultImei(imei)
          }else {
            this.setCarInfoByImei()
          }
        }
      });
    },
    predictCarInfo(imei,sn){
      this.$axios.post('/v3/u/user/predictCarInfo',{imei,sn}).then((res) =>{
        if (res.data.ret === 0) {
            const resData = res.data.data;
            const requiredField = resData.requiredField;
            const requiredFieldValue = requiredField.map(item=>resData[item])
            const isEveryFieldFillFull = requiredFieldValue.every(x=>!!x);
            if(isEveryFieldFillFull){
              this.bindDeviceWithImeiAndSn({...resData,imei,sn})
            }else{
              this.$toast.clear();
              this.$router.replace({name:'carPlate',query:{imei,sn}});
            }
          }else{
            this.$toast.clear();
            this.$dialog({
              message: res.data.msg ? res.data.msg + '（' + res.data.ret + '）' : '获取车辆信息失败（' + res.data.ret + '）'
            })
          }
      })
    },

    setCarInfoByImei () {
        this.$axios.post('/v3/u/user/getAllVehicle',{}).then((response) =>{
          if (response.data.ret === 0) {
            let reqData = response.data.data;
            if(reqData.length){
              const findOtherDevice = (reqData||[]).shift();
              this.setDefaultImei(findOtherDevice.imei)
            }else{
              this.$cookies.set('imei', "");
              this.$router.replace('/');
            }
          }else{
            this.$toast.clear();
            this.$dialog({
              message: response.data.msg ? response.data.msg + '（' + response.data.ret + '）' : '获取设备列表失败（' + response.data.ret + '）'
            })
          }
        })

    },
    setDefaultImei(imei){
      this.$axios.post('/v3/u/user/setFavoriteVehicle',{imei:imei}).then(res=>{
        this.$toast.clear();
        if (res.data.ret === 0) {
            this.$cookies.set('imei', imei);
            this.$router.replace('/');
          }else{
            this.$dialog({
              message: res.data.msg ? res.data.msg + '（' + res.data.ret + '）' : '设置缺省设备失败（' + res.data.ret + '）'
            })
          }
      })
    },
   bindDeviceWithImeiAndSn(data){
      this.$axios.post('/v3/u/user/bindVehicle',data).then(res=>{
        if (res.data.ret === 0) {
            this.setDefaultImei(data.imei)
          }else{
            this.$toast.clear();
            this.$dialog({
              message: res.data.msg ? res.data.msg + '（' + res.data.ret + '）' : '绑定设备失败（' + res.data.ret + '）'
            })
          }

      })
    },
    // 获取手机验证码
    getWxVerifyCodeFn() {
      let mobile = this.bdPhoneNumber;
      this.bdVerifyCode = '';
      // if (!formCheck.checkPhone(mobile)) {
      //   return this.$toast('请填写正确的手机号码');
      // }
      const mobileWithPre = `${this.prePhoneValue}${mobile}`
      // 发送验证码
      this.$axios.post('/v3/u/user/getCode', {
        mobile:mobileWithPre,
        customer: this.$cookies.get('customer'), // customer用于后台判断该手机号是否已经绑定了微信和设备
      }).then((res) => {
        if (res.data.ret === 0) {
          this.$toast('验证码已发送');
          this.countDisabled = true;
          this.countDownFn();
        } else {
          this.$dialog({
            message: res.data.msg
          });
        }
      });
    },
    // 倒计时
    countDownFn() {
      let yzmText = 60;
      this.bdYzmText = `${yzmText}s`;
      let setIntervalFn = setInterval(() => {
        yzmText--;
        this.bdYzmText = `${yzmText}s`;
        if (yzmText < 1) {
          clearInterval(setIntervalFn);
          this.bdYzmText = '重新获取';
          this.countDisabled = false;
        }
      }, 1000);
    },
  },
  created() {
    this.bindingBG = this.$cookies.get('customer')==='ZhenBeiZhiLian'?'zhenbeizhilian':"other";
  }
}
</script>
